import axios, { endpoints } from 'src/utils/axios';
import handleOKRequest from 'src/components/grids/generic-grid/handleOKRequest';
import handleBadRequest from 'src/components/grids/generic-grid/handleBadRequest';
import { createAsyncThunk } from '@reduxjs/toolkit';

//Modificar de acuerdo a la lógica de la acción
export const verificarProveedorF = createAsyncThunk(
  'proveedorForm/verificarProveedorF',
  async (
    { data, formRef }: { data: any; formRef: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.put(
        endpoints.actions.verificarProveedorF,
        data
      );
      formRef.current.instance.updateData({ id: response.data });
      handleOKRequest(response, 'Proveedor verificado correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al verificar el proveedor.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const rechazarProveedorF = createAsyncThunk(
  'proveedorForm/rechazarProveedorF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.rechazarProveedorF,
        data
      );
      handleOKRequest(response, 'Proveedor rechazado correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al rechazar el proveedor.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarConReservaProveedorF = createAsyncThunk(
  'proveedorForm/marcarConReservaProveedorF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.marcarConReservaProveedorF,
        data
      );
      handleOKRequest(
        response,
        'Proveedor marcado "Con Reserva" correctamente.'
      );
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al marcar el proveedor "Con Reserva".'
      );
    }
  }
);
